export default function(_) {
  return typeof _ === 'string';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isString.js